import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import HavnsLogo from "../components/HavnsLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef (not useState) for the processed flag to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace("#", ""));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          console.error("No session_id found");
          navigate("/");
          return;
        }

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data;
        setUser(userData);

        // Navigate based on user status
        if (userData.application_status === "approved" && userData.payment_status === "completed") {
          navigate("/dashboard", { replace: true, state: { user: userData } });
        } else {
          navigate("/application", { replace: true, state: { user: userData } });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/");
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-ivory flex items-center justify-center">
      <div className="text-center stagger-children">
        <HavnsLogo className="text-2xl justify-center mb-4" linkTo="/" />
        <p className="text-caption">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
